import { observable, action, configure, makeAutoObservable } from 'mobx';

import URL from '_common/constants/URL';
import * as req from '_common/utils/req';

configure({
  enforceActions: 'always',
});
export default class earnStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      userBalance: observable,
      userTransactions: observable,
      userActiveOrders: observable,
      userHistoryOrders: observable,
      redeemRule: observable,
      changeableProjects: observable,
      changeRule: observable,
      currencies: observable,
      hasUncheckedFailedBills: observable,
      fetchUserBalance: action,
      fetchUserActiveOrders: action,
      fetchRedeemRule: action,
      redeem: action,
      change: action,
      fetchChangeRule: action,
      fetchChangeableProjects: action,
      fetchUserHistoryOrders: action,
      fetchUserTransactions: action,
      fetchCurrencies: action,
      userHasUncheckedFailedBills: action,
      setUserBalance: action,
      setRedeemRule: action,
      setChangeRule: action,
      setUserActiveOrders: action,
      setUserHistoryOrders: action,
      setUserTransactions: action,
      setChangeableProjects: action,
      setCurrencies: action,
      setHasUncheckedFailedBills: action,
      fetchBillTypes: action,
    });

    this.rootStore = rootStore;
  }

  projectTypeEnum = {
    1: 'jp.earn.projectType.staking', // 锁仓挖矿
    2: 'jp.earn.projectType.flashDeal', // flashDeal
    3: 'earn_product_lending', // lending
  };

  billTypeEnum = {
    0: 'jp.earn.billType.subscribe', // 申請
    1: 'jp.earn.billType.unsubscribe', // 解約
    2: 'jp.earn.billType.interest', // 利息
    4: 'jp.earn.billType.fee', // 手数料
    5: 'jp.earn.billType.change', // 変更
  };

  orderStatusEnum = {
    0: 'jp.earn.order.status.redeemed', // 返済済み
    1: 'jp.earn.order.status.new', // 新規購入、「Earning中」と表示
    2: 'jp.earn.order.status.earning', // 利息起算中、「Earning中」と表示
    3: 'jp.earn.order.status.redeeming', // 返済中
    4: 'jp.earn.order.status.processingSubscribe', // 申請処理中
    5: 'jp.earn.order.status.failed', // 申請失敗
    6: 'jp.earn.order.status.processingRedeem', // 解約処理中
    7: 'jp.earn.order.status.processingChange', // 変更処理中
  };

  billStatusEnum = {
    0: 'jp.earn.bill.status.processing', // 处理中
    1: 'jp.earn.bill.status.complete', // 已完成
    2: 'jp.earn.bill.status.failed', // 失败
  };

  userBalance = {};
  userTransactions = [];
  userActiveOrders = [];
  userHistoryOrders = [];
  redeemRule = {};
  changeableProjects = [];
  changeRule = {};
  currencies = [];
  hasUncheckedFailedBills = false;

  fetchUserBalance = () => {
    req.getData(
      URL.GET_EARN_USER_BALANCE,
      {},
      (r) => {
        const data = r.data;
        this.setUserBalance(data);
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  fetchUserActiveOrders = (pageParams, setPage) => {
    this.rootStore.loadingStore.showLoading();
    req.getData(
      URL.GET_EARN_USER_ACTIVE_ORDERS,
      pageParams,
      (r) => {
        const data = r.data;
        this.setUserActiveOrders(data.list);
        if (typeof setPage == 'function') {
          setPage(data.currentPage, data.pageLength, data.total);
        }
        this.rootStore.loadingStore.hideLoading();
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
        this.rootStore.loadingStore.hideLoading();
      }
    );
  };

  fetchRedeemRule = (orderId, successCallback) => {
    req.getData(
      URL.GET_EARN_REDEEM_RULE,
      { orderId },
      (r) => {
        const data = r.data;
        this.setRedeemRule(data);
        if (r.data && typeof successCallback === 'function') {
          successCallback();
        }
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  redeem = (orderId, successCallback, errorCallback) => {
    const params = { orderId };
    req.postData(
      URL.POST_EARN_REDEEM,
      params,
      (r) => {
        if (r.data && typeof successCallback === 'function') {
          successCallback();
        }
      },
      (error) => {
        if (typeof errorCallback === 'function') {
          errorCallback();
        }
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  change = (orderId, projectId, successCallback, errorCallback) => {
    const params = { orderId, projectId };
    req.postData(
      URL.POST_EARN_CHANGE,
      params,
      (r) => {
        if (r.data && typeof successCallback === 'function') {
          successCallback();
        }
      },
      (error) => {
        if (typeof errorCallback === 'function') {
          errorCallback();
        }
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  fetchChangeRule = (orderId, projectId, successCallback) => {
    const params = { orderId, projectId };
    req.getData(
      URL.GET_EARN_CHANGE_RULE,
      params,
      (r) => {
        const data = r.data;
        this.setChangeRule(data);
        if (typeof successCallback === 'function') {
          successCallback();
        }
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  fetchChangeableProjects = (orderId, successCallback) => {
    const params = { orderId };
    req.getData(
      URL.GET_EARN_CHANGEABLE_PROJECTS,
      params,
      (r) => {
        const data = r.data;
        this.setChangeableProjects(data);
        if (typeof successCallback === 'function') {
          successCallback();
        }
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  fetchUserHistoryOrders = (pageParams, setPage) => {
    this.rootStore.loadingStore.showLoading();
    req.getData(
      URL.GET_EARN_USER_HISTORY_ORDERS,
      pageParams,
      (r) => {
        const data = r.data;
        this.setUserHistoryOrders(data.list);
        if (typeof setPage == 'function') {
          setPage(data.currentPage, data.pageLength, data.total);
        }
        this.rootStore.loadingStore.hideLoading();
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
        this.rootStore.loadingStore.hideLoading();
      }
    );
  };

  fetchUserTransactions = (pageParams, setPage) => {
    this.rootStore.loadingStore.showLoading();
    req.getData(
      URL.GET_EARN_USER_BILL,
      pageParams,
      (r) => {
        const data = r.data;
        this.setUserTransactions(data.list);
        if (typeof setPage == 'function') {
          setPage(data.currentPage, data.pageLength, data.total);
        }
        this.rootStore.loadingStore.hideLoading();
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
        this.rootStore.loadingStore.hideLoading();
      }
    );
  };

  fetchCurrencies = () => {
    req.getData(URL.GET_EARN_CURRENCIES, {}, (r) => {
      const data = r.data;
      const currencyIdSet = new Set();
      const array = data.filter((item) => {
        if (currencyIdSet.has(item.currencyId)) {
          return false;
        }
        currencyIdSet.add(item.currencyId);
        return true;
      });
      this.setCurrencies(array);
    });
  };

  userHasUncheckedFailedBills = () => {
    req.getData(URL.GET_EARN_USER_HAS_UNCHECKED_FAILED_BILLS, {}, (r) => {
      const data = r.data;
      const result = data.result;
      this.setHasUncheckedFailedBills(result);
    });
  };

  fetchBillTypes = (callback) => {
    req.getData(
      URL.GET_BILL_TYPES,
      {},
      (r) => {
        const data = r.data;
        callback(
          data.map((T) => {
            return { value: T.type, label: T.typeName };
          })
        );
      },
      (error) => {
        this.rootStore.loadingStore.showErrorDialog(error.msg);
      }
    );
  };

  setUserBalance = (value) => {
    this.userBalance = value;
  };

  setRedeemRule = (value) => {
    this.redeemRule = value;
  };

  setChangeRule = (value) => {
    this.changeRule = value;
  };

  setUserActiveOrders = (value) => {
    this.userActiveOrders = value;
  };

  setUserHistoryOrders = (value) => {
    this.userHistoryOrders = value;
  };

  setUserTransactions = (value) => {
    this.userTransactions = value;
  };

  setChangeableProjects = (value) => {
    this.changeableProjects = value;
  };

  setCurrencies = (value) => {
    this.currencies = value;
  };

  setHasUncheckedFailedBills = (value) => {
    this.hasUncheckedFailedBills = value;
  };
}
